import { render } from "./DashboardViewEx.vue?vue&type=template&id=60a5b45e"
import script from "./DashboardViewEx.vue?vue&type=script&lang=js"
export * from "./DashboardViewEx.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__